import { render } from "./Tavern.vue?vue&type=template&id=7198258c"
import script from "./Tavern.vue?vue&type=script&lang=js"
export * from "./Tavern.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/buildings/Tavern.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7198258c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7198258c', __exports__)) {
    api.reload('7198258c', __exports__)
  }
  
  module.hot.accept("./Tavern.vue?vue&type=template&id=7198258c", () => {
    api.rerender('7198258c', render)
  })

}


export default __exports__